// @flow
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import { User } from '../../types'
import Table from '../../components/Table'
import Tr from '../../components/Tr'
import Th from '../../components/Th'
import Td from '../../components/Td'

type Props = {
  user: User
}

const AdminUserFavorites = ({ user }: Props) => {
  const favorites = user.favorites || []

  return (
    <div>
      <Table>
        <thead>
          <Tr>
            <Th>ID</Th>
          </Tr>
        </thead>
        <tbody>
          {favorites.map((favorite) => (
            <Tr key={favorite.id}>
              <Td>
                <Link to={`/properties/${favorite.mls_id}`}>
                  {favorite.mls_id}
                </Link>
              </Td>
            </Tr>
          ))}
        </tbody>
      </Table>
    </div>
  )
}

export default connect((state) => ({
  user: state.admin.user
}))(AdminUserFavorites)



// WEBPACK FOOTER //
// ./src/views/AdminUserFavorites/index.js